import React, { useCallback } from 'react';
import { Link, NavLink } from 'react-router-dom';

import { Nav, Navbar } from 'react-bootstrap';
import { useAuth } from '../../hooks/auth';
import { useAlert } from '../../hooks/alert';

import { Container, Greeting } from './styles';

import logo from '../../assets/logo.png';
import publicidadeLegal from '../../assets/publicidade-legal-2.png';

const Header: React.FC = () => {
  const { user, signOut } = useAuth();
  const { showAlert } = useAlert();

  const showBlock = useCallback(() => {
    showAlert({
      type: 'info',
      title: 'Recurso desabilitado',
      description:
  <>
    <p>
      Olá! O recurso de cadastramento está temporariamente desabilitado.
      Para mais informações ligue para 51 3213 1338 ou envie e-mail para
      {` `}
      <a href='mailto:comercial@jornaldocomercio.com.br'>
        comercial@jornaldocomercio.com.br
      </a>
      .
    </p>
  </>,
    });
  }, []);

  return (
    <>
      <Container>
        <div className="row">
          <div className="col-12 col-md-8 col-lg-6 offset-0 offset-lg-3 justify-content-center">
            <NavLink exact activeClassName="active" to="/">
              <img src={logo} alt="Jornal do Comércio" className="logo" />
            </NavLink>
          </div>
          <div className="d-none col-md-4 col-lg-3 d-md-flex align-items-center justify-content-end">
            {/* {user ? (
              <Greeting>
                <div className="usuario-logado">
                  <Link to="/budgets" className="nome" title={user.name}>
                    {`Olá, ${user.name}!`}
                  </Link>
                  <button type="button" onClick={signOut} className="sair">
                    SAIR
                  </button>
                </div>
                <Link to="/budgets" className="btn btn-borda-arredondada">
                  Área restrita
                </Link>
              </Greeting>
            ) : (
              <Greeting>
                <Link to="/budgets" className="btn btn-borda-arredondada">
                  Área restrita
                </Link>
              </Greeting>
            )} */}
            {/* <Greeting>
              <a
                href="#"
                onClick={showBlock}
                className="btn btn-borda-arredondada"
              >
                Área restrita
              </a>
            </Greeting> */}
          </div>
        </div>

        <Navbar bg="light" expand="md">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Greeting className="d-flex d-md-none">
            {/* {user ? (
              <div className="usuario-logado">
                <Link to="/budgets" className="nome" title={user.name}>
                  {`Olá, ${user.name}!`}
                </Link>
                <button type="button" onClick={signOut} className="sair">
                  SAIR
                </button>
              </div>
            ) : (
              <Link to="/budgets" className="btn btn-borda-arredondada">
                Área restrita
              </Link>
            )} */}
            <a
              href="#"
              onClick={showBlock}
              className="btn btn-borda-arredondada"
            >
              Área restrita
            </a>
          </Greeting>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <NavLink exact activeClassName="active" to="/">
                Página inicial
              </NavLink>
              <NavLink activeClassName="active" to="/standards">
                Normas
              </NavLink>
              <NavLink activeClassName="active" to="/prices">
                Consulta de valores
              </NavLink>
              <NavLink activeClassName="active" to="/faq">
                Dúvidas frequentes
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <div className="cabecalho">
          <Link to="/">
            <img src={publicidadeLegal} alt="Publicidade Legal" />
          </Link>
        </div>
      </Container>
    </>
  );
};

export default Header;
